// extracted by mini-css-extract-plugin
export default {"topbarMenu":"MinMenu_topbarMenu__4tIyy"};